import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  Renderer2,
  ViewChildren,
  QueryList,
  Output,
  Input,
  TemplateRef,
  HostListener,
  Inject,
} from '@angular/core';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { ApiService } from 'src/app/core/services/api.service';
import { ProcedureService } from '../../../../../../core/services/procedure.service';
import {
  MatDialogRef,
  MatDialog,
  MatExpansionPanel,
  MatTableDataSource,
  MatSort,
  MatSelect,
  MAT_DIALOG_DATA,
} from '@angular/material';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { FormControl, NgForm, FormGroup, Validators } from '@angular/forms';
import { first, map, takeUntil } from 'rxjs/operators';
import { Subject, ReplaySubject, BehaviorSubject, fromEvent } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Observable } from 'rxjs/Observable';
import { NzConfigService } from 'ng-zorro-antd/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CustomerService } from 'src/app/core/services/customer.service';
import { DocumentCustomerEntity } from 'src/app/core/class/document-customer-entity';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import { EnterpriseEntity } from 'src/app/core/class/enterpriseEntity';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { UserEntity } from 'src/app/core/class/UserEntity';
import { DocumentService } from 'src/app/core/services/document.service';
import { EventEmitter } from '@angular/core';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';
import { AddCustomerDialogComponent } from '../../customer/customer/add-customer/add-customer-dialog/add-customer-dialog.component';
import {
  EnumContractEnterpriseStatus,
  EnumContractUserRole,
} from 'src/app/core/constants/contract';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { ActivatedRoute } from '@angular/router';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { stringToUTF8String } from 'src/assets/js/pdf.worker-2.6.423';

@Component({
  selector: 'app-add-config-ip',
  templateUrl: './add-config-ip.component.html',
  styleUrls: ['./add-config-ip.component.scss'],
})
export class AddConfigIpComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  constructor(
    private documentService: DocumentService,
    private apiService: ApiService,
    private el: ElementRef,
    private createContractService: CreateContractService,
    public dialogRef: MatDialogRef<AddConfigIpComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    private modelService: NzModalService,
    private nzConfigService: NzConfigService,
    private customerService: CustomerService,
    public autoUserService: AutoUserService,
    private route: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    public autoEnterpriseService: AutoEnterpriseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe((_) => {
      this.onNoClick();
    });
    this.mode = data.mode;
    this.listIpCurrent = data.ipAlloweds;
    if (data.ipSelected) {
      this.ipSelected = data.ipSelected;
    }
  }
  ipSelected:any = {};
  mode: string = 'ADD';
  listIpCurrent: any[] = [];
  isFormChanging: boolean = false;
  formGroup = new FormGroup({
    ip: new FormControl('', [Validators.required, Validators.pattern(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/)]),
    description: new FormControl('')
  });
  ngOnInit() {
    this.formGroup.valueChanges.subscribe(value => {
      this.isFormChanging = true;
    })
    if (this.mode === 'EDIT') {
      this.formGroup.patchValue(this.ipSelected);
      this.isFormChanging = false;
    }
  }
  ngOnDestroy() {}
    /**
   * Close adding branch dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('messages.confirm_change_data'),
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        this.dialogRef.close();
      }
      dialogRe.close();
    });
    } else {
      this.dialogRef.close();
    }
  }
  get ipControl() {
    return this.formGroup.get('ip');
  }

  get desControl() {
    return this.formGroup.get('description');
  }
  getIpErrorMessage() {
    if (this.ipControl.hasError('required')) {
      return this.message.getMessage('config_enterprise.ip_required');
    }
    if (this.ipControl.hasError('pattern')) {
      return this.message.getMessage('config_enterprise.ip_pattent');
    }
    return '';
  }
  clearData(formControlName: string) {
    if (formControlName === 'ip') {
      this.ipControl.patchValue('');
    } else {
      this.desControl.patchValue('');
    }
  }
  focusOut(formControlName: string) {
    if (formControlName === 'ip') {
      const ipValue = this.ipControl.value ? this.ipControl.value.trim() : '';
      this.ipControl.patchValue(ipValue);
    } else {
      const desValue = this.desControl.value ? this.desControl.value.trim() : '';
      this.desControl.patchValue(desValue);
    }
  }

  onSubmit() {
    this.formGroup.markAllAsTouched();
    if (!this.formGroup.valid) {
      return;
    } else {
      const formValue = this.formGroup.value;
      if (this.mode === 'ADD') {
        const dataIp = this.listIpCurrent.find(ipData => ipData.ip.trim() === formValue.ip.trim());
        if (dataIp) {
          this.toastr.error(this.message.getMessage('config_enterprise.ip_is_duplicate'));
          return;
        } else {
          const ipAdd = {
            ...formValue,
            id: this.commonService.generateUUID()
          }
          this.dialogRef.close(ipAdd);
          this.toastr.success(this.message.getMessage('config_enterprise.add_ip_success'));
        }
      } else {
        const dataIp = this.listIpCurrent.find(ipData => ipData.ip.trim() === formValue.ip.trim() && this.ipSelected.id !== ipData.id);
        if (dataIp) {
          this.toastr.error(this.message.getMessage('config_enterprise.ip_is_duplicate'));
          return;
        } else {
          const ipUpdate = {
            ...formValue,
            id: this.ipSelected.id
          }
          this.dialogRef.close(ipUpdate);
          this.toastr.success(this.message.getMessage('config_enterprise.update_ip_success'));
        }
      }
    }
  }

  checkDisableSave() {
    let disable:boolean = true;
    if (this.mode === 'ADD') {
      if (this.ipControl.value.length > 0) {
        disable = false;
      }
    } else {
      if (this.ipControl.value.length > 0 && this.isFormChanging) {
        disable = false;
      }
    }
    return disable;
  }
}
